var styleDataHash = "61f2f1c3";
const injectCss = () => {
  var css = `.FkmEl{height:18px;position:relative;width:18px}.iA-IP,.n6XB-{height:100%;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}[dir=ltr] .iA-IP,[dir=ltr] .n6XB-{left:0}[dir=rtl] .iA-IP,[dir=rtl] .n6XB-{right:0}.iA-IP{stroke:currentColor;opacity:.3}[dir=ltr] .iA-IP{animation:aAvfo 666ms linear infinite}[dir=rtl] .iA-IP{animation:_6fpaW 666ms linear infinite}.n6XB-{stroke:currentColor}[dir=ltr] .n6XB-{animation:aAvfo 2s linear infinite}[dir=rtl] .n6XB-{animation:_6fpaW 2s linear infinite}@keyframes aAvfo{to{transform:rotate(1turn)}}@keyframes _6fpaW{to{transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var double_loader_default = {
  "wrapper": "FkmEl",
  "top": "iA-IP",
  "bottom": "n6XB-",
  "rotation-ltr": "aAvfo",
  "rotation-rtl": "_6fpaW"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
